/* 🤖 this file was generated by svg-to-ts */
export const emperorIconVideoControlPlay: {
  name: 'video_control_play';
  data: string;
} = {
  name: 'video_control_play',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><path d="M5 3.259v17.48l14.98-8.75L4.99 3.24Zm2 3.48l9.015 5.25L7 17.248V6.73Z"/></svg>`
};
